<template>
	<div class="user-panel">
		<header>Dane podstawowe</header>
		<dl>
			<dt>Imię Nazwisko</dt>
			<dd>{{ myFx.firstName }} {{ myFx.lastName }}</dd>

			<dt>Data Urodzenia</dt>
			<dd>
				{{ $filters.date(myFx.dateOfBirth) }}
			</dd>

			<dt>PESEL</dt>
			<dd>{{ myFx.pesel }}</dd>

			<dt>Obywatelstwo</dt>
			<dd>
				<template v-if="myFx.citizenshipId">{{ getDictionaryItem(countries, 'text', 'value', myFx.citizenshipId) }}</template>
			</dd>
			<template v-if="myFx.haveMotherMaidenName">
				<dt>Nazwisko panieńskie matki</dt>
				<dd>
					{{ myFx.motherMaidenName }}
				</dd>
			</template>
		</dl>
		<div class="user-panel-form clearfix">
			<div class="form-col">
				<v-select :label="'Kraj urodzenia'" :htmlId="'BirthCountry'" :list="countries" :itemTypeToSave="'text'" :searchable="true" :value="myFx.birthCountry" />
				<v-input :label="'Miejscowość urodzenia'" :htmlId="'BirthPlace'" :value="myFx.birthPlace" />
				<v-select v-if="myFx.documentTypeId" :label="'Rodzaj dokumentu tożsamości'" :htmlId="'DocumentTypeId'" :list="documentsType" :value="myFx.documentTypeId.toString()" />
				<template v-if="!myFx.haveMotherMaidenName">
					<v-input :label="'Nazwisko panieńskie matki'" :htmlId="'MotherMaidenName'" :value="myFx.motherMaidenName" />
				</template>
				<v-input :label="'Numer dokumentu tożsamości'" :htmlId="'DocumentNumber'" :value="myFx.documentNumber" :readonly="myFx.documentTypeId === 3" />
				<v-datepicker v-if="!myFx.documentNotExpiring || myFx.documentTypeId == 1 || !myFx.canChangeDocumentNotExpiring" :label="'Data ważności dokumentu'" :htmlId="'DocumentValidityDate'" :value="myFx.documentValidityDate" :disabled="myFx.documentTypeId === 3" style="width: 100%" />
				<div v-if="myFx.documentTypeId == 2 && myFx.canChangeDocumentNotExpiring" class="checkbox checkbox-lg">
					<input :checked="myFx.documentNotExpiring" @change="updateNotExpired($event)" type="checkbox" id="DocumentExpiringShow" />
					<label for="DocumentExpiringShow">Ważny bezterminowo</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
import { getMyFx } from '@/mixins/get-my-fx';

export default {
	mixins: [getDictionaryItem, getMyFx],
	props: {
		countries: {
			type: Array,
			required: true,
		},
		documentsType: {
			type: Array,
			required: true,
		},
	},
	methods: {
		updateNotExpired(e) {
			this.$store.commit('setDocumentNotExpiring', e.target.checked);
			if (e.target.checked) this.$store.commit('setDocumentValidityDate', null);
		},
	},
};
</script>
